import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { agentroomrestriction } from "../../Services/Service";

// Thunk: meal plan select hone par restriction check karega
export const fetchAgentRoomRestriction = createAsyncThunk(
  "agentRoomRestriction/fetch",
  async (
    { roomID, PropertyID, CheckInDate, CheckOutDate, RateCode, RoomCode },
    { rejectWithValue }
  ) => {
    try {
      const response = await agentroomrestriction(
        PropertyID,
        CheckInDate,
        CheckOutDate,
        RateCode,
        RoomCode
      );

      // response expected: ["0"] ya ["1"]
      const raw = Array.isArray(response) ? response[0] : response;
      const restricted = String(raw) === "0"; // "0" => room not available

      return { roomID, restricted };
    } catch (error) {
      return rejectWithValue({ roomID, error: error?.message || "Error" });
    }
  }
);

const agentRoomRestrictionSlice = createSlice({
  name: "agentRoomRestriction",
  initialState: {
    byRoomID: {}, // { [roomID]: { loading, restricted, error } }
  },
  reducers: {
    resetRoomRestriction: (state, action) => {
      const roomID = action.payload;
      if (roomID !== undefined) {
        delete state.byRoomID[roomID];
      } else {
        state.byRoomID = {};
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAgentRoomRestriction.pending, (state, action) => {
        const { roomID } = action.meta.arg;
        state.byRoomID[roomID] = {
          ...(state.byRoomID[roomID] || {}),
          loading: true,
          error: null,
        };
      })
      .addCase(fetchAgentRoomRestriction.fulfilled, (state, action) => {
        const { roomID, restricted } = action.payload;
        state.byRoomID[roomID] = { loading: false, restricted, error: null };
      })
      .addCase(fetchAgentRoomRestriction.rejected, (state, action) => {
        const { roomID, error } = action.payload || {};
        if (roomID !== undefined) {
          state.byRoomID[roomID] = { loading: false, restricted: false, error };
        }
      });
  },
});

export const { resetRoomRestriction } = agentRoomRestrictionSlice.actions;
export default agentRoomRestrictionSlice.reducer;